module.exports = __webpack_public_path__ + "img/SoWonderful_Logo_RZ_schwarz.jpg";